module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    key: _vm._isColmo + 'minibar',
    class: ['minibar-wrapper', _vm.hasBottomBorder && 'bottom-border', _vm.isFixed && 'isFixed'],
    style: {
      'background-color': _vm.backgroundColor_
    }
  }, [_c('div', {
    staticClass: ["dof-minibar"],
    style: _vm.newBarStyle
  }, [_c('div', {
    staticClass: ["left"],
    attrs: {
      "ariaLabel": _vm.leftButtonBlindHelp,
      "accessible": true
    },
    on: {
      "click": _vm.leftButtonClicked
    }
  }, [_vm._t("left", [(_vm.leftButton_ && !_vm.leftText) ? _c('image', {
    staticClass: ["left-button"],
    attrs: {
      "src": _vm.leftButton_
    }
  }) : _vm._e(), (!_vm.leftButton_ && !_vm.leftText && _vm._isColmo) ? _c('dof-iconfont', {
    staticStyle: {
      width: "58px"
    },
    attrs: {
      "code": '\u4717',
      "size": 64,
      "color": 'rgba(255,255,255,0.80)'
    },
    on: {
      "dofIconFontClicked": _vm.leftButtonClicked
    }
  }) : _vm._e(), (_vm.leftText) ? _c('text', {
    staticClass: ["icon-text"],
    style: _vm.newTextStyle
  }, [_vm._v(_vm._s(_vm.leftText))]) : _vm._e()])], 2), _vm._t("middle", [_c('div', {
    staticClass: ["middle-title-wrapper"]
  }, [_c('text', {
    staticClass: ["middle-title"],
    style: _vm.newTextWrapStyle,
    attrs: {
      "ariaLabel": _vm.title ? _vm.title + '。文本。' : ''
    }
  }, [_vm._v(_vm._s(_vm.title))]), (_vm.subTitle) ? _c('text', {
    staticClass: ["middle-sub-title"],
    style: _vm.newTextWrapStyleSubTitle,
    attrs: {
      "ariaLabel": _vm.subTitle ? _vm.subTitle + '。文本。' : ''
    }
  }, [_vm._v(_vm._s(_vm.subTitle))]) : _vm._e()])]), _c('div', {
    staticClass: ["right"],
    on: {
      "click": _vm.rightButtonClicked
    }
  }, [_vm._t("right", [(_vm.rightButton_ && _vm.rightButton_ !== 'default' && !_vm.rightText) ? _c('image', {
    staticClass: ["right-button"],
    attrs: {
      "src": _vm.rightButton_,
      "ariaHidden": true
    }
  }) : _vm._e(), (_vm.rightButton_ === 'default' && _vm._isColmo && !_vm.rightText) ? _c('dof-iconfont', {
    staticClass: ["right-button"],
    attrs: {
      "code": '\u4807',
      "size": 64
    },
    on: {
      "dofIconFontClicked": _vm.rightButtonClicked
    }
  }) : _vm._e(), (_vm.rightText) ? _c('text', {
    staticClass: ["icon-text"],
    style: _vm.newTextStyle,
    attrs: {
      "ariaLabel": _vm.rightText ? _vm.rightText + '。按钮。' : ''
    }
  }, [_vm._v(_vm._s(_vm.rightText))]) : _vm._e()])], 2)], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-57c74639!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-minibar/index.vue
// module id = 620
// module chunks = 0 1